import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useCopyToClipboard } from '../../../hooks';
import { autoLoginUserStart } from '../../../redux/user/user.actions';
import useTranslation from 'hooks/useTranslation';
import { getWidgetInstallSrcUrl } from 'utils/url';
import './styles.scss';
import { RAYCHAT_WIDGET_INSTALL_URL } from 'utils/constants';

const mapState = ({ appData }) => ({
  unregisteredUser: appData.unregisteredUser,
  widgetToken: appData.widgetToken,
  locale: appData.locale,
});

const DashobardLandingCard = (props) => {
  const { unregisteredUser, widgetToken, locale } = useSelector(mapState);
  const dispatch = useDispatch();
  const history = useHistory();

  const { getTranslation } = useTranslation('AUTH');
  const { t } = getTranslation();

  // NOTE: this code is repeated in source. consider when refactoring
  const widgetCode = `
  <script type="text/javascript">
  window.RAYCHAT_TOKEN = "${widgetToken}";
    (function () {
      d = document;
      s = d.createElement("script");
      s.src = "${getWidgetInstallSrcUrl(locale)}";
      s.async = 1;
      d.getElementsByTagName("head")[0].appendChild(s);
    })();
  </script>
  `;

  const copyToClipboard = useCopyToClipboard(widgetCode);

  const handleLogin = (event) => {
    event.preventDefault();
    const userCredentials = {
      email: unregisteredUser.email,
      password: unregisteredUser.password,
    };
    dispatch(autoLoginUserStart({ userCredentials, history }));
  };

  const handleCopyWidgetCode = (event) => {
    event.preventDefault();
    copyToClipboard();
  };

  const renderDescription = () => {
    if (locale === 'en') {
      return (
        <>
          For widget installation add this script to the end of your website's
          <code>
            {' '}
            <strong>head</strong>
          </code>{' '}
          tag
        </>
      );
    }

    return (
      <>
        برای نمایش ابزارک تکه کد زیر را قبل از اتمام تگ
        <code>
          <strong> &nbsp;head </strong>
        </code>
        در سایتتان جایگذاری کنید.
      </>
    );
  };

  const renderCrmDescription = (
    <div className='signup_box_crm'>
      <p>{t('LANDING_CARD').FOOTER}</p>
    </div>
  );
  return (
    <div className='signup_box'>
      <h4>{t('LANDING_CARD').TITLE}</h4>
      <p className='description'>{renderDescription()}</p>
      <div className='signup_box_installcode'>
        <code>
          <code className='widgetInstallationCode'>
            <span>{'<script type="text/javascript">'}</span>
            <span>{`  window.RAYCHAT_TOKEN = "${widgetToken}";`}</span>
            <span>{'  (function () {'}</span>
            <span>{'    d = document;'}</span>
            <span>{'    s = d.createElement("script");'}</span>
            <span>{`    s.src = "${RAYCHAT_WIDGET_INSTALL_URL}";`}</span>
            <span>{'    s.async = 1;'}</span>
            <span>{'  d.getElementsByTagName("head")[0].appendChild(s);'}</span>
            <span>{'  })();'}</span>
            <span>{'</script>'}</span>
          </code>
        </code>
        <a
          href='#/'
          className='btn copybtn'
          onClick={handleCopyWidgetCode}
          rel='noopener noreferrer'
        >
          {t('LANDING_CARD').COPY_BTN}
        </a>
      </div>
      {renderCrmDescription}
      <div className='signup_box_login'>
        <a
          href='#/'
          onClick={handleLogin}
          className='btn btn-primary'
          rel='noopener noreferrer'
        >
          {t('LANDING_CARD').SUBMIT_BTN}
        </a>
      </div>
    </div>
  );
};

export default DashobardLandingCard;
